// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { BaseMapInfo } from './BaseMapInfo';

export class VisibleTiles implements IVisibleTiles {
    topLeftTileX!: number;
    topLeftTileY!: number;
    tileCountX!: number;
    tileCountY!: number;

    constructor(data?: IVisibleTiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topLeftTileX = _data["topLeftTileX"];
            this.topLeftTileY = _data["topLeftTileY"];
            this.tileCountX = _data["tileCountX"];
            this.tileCountY = _data["tileCountY"];
        }
    }

    static fromJS(data: any): VisibleTiles {
        data = typeof data === 'object' ? data : {};
        let result = new VisibleTiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topLeftTileX"] = this.topLeftTileX;
        data["topLeftTileY"] = this.topLeftTileY;
        data["tileCountX"] = this.tileCountX;
        data["tileCountY"] = this.tileCountY;
        return data;
    }
}

export interface IVisibleTiles {
    topLeftTileX: number;
    topLeftTileY: number;
    tileCountX: number;
    tileCountY: number;
}